import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { ThemeProvider } from "./context/ThemeContext";
import { AuthProvider } from "./context/AuthContext";
import { FontSizeProvider } from "./context/FontSizeContext";
import { I18nProvider } from "./lib/i18n";
import { PageLayout } from "./components/Layout";
import Home from "./pages/Home";
import Manifesto from "./pages/Manifesto";
import Library from "./pages/Library";
import ArticleDetail from "./pages/ArticleDetail";
import HelpRequest from "./pages/HelpRequest";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import AuthCallback from "./pages/AuthCallback";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import Transparency from "./pages/Transparency";
import Collaborators from "./pages/Collaborators";
import Testimonials from "./pages/Testimonials";
import Contact from "./pages/Contact";
import Diary from "./pages/Diary";
import Archive from "./pages/Archive";
import Assistant from "./pages/Assistant";
import Admin from "./pages/Admin";
import Results from "./pages/Results";
import Settings from "./pages/Settings";

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <PageLayout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/manifesto" element={<Manifesto />} />
        <Route path="/library" element={<Library />} />
        <Route path="/library/:id" element={<ArticleDetail />} />
        <Route path="/help" element={<HelpRequest />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/:id" element={<ProjectDetail />} />
        <Route path="/transparency" element={<Transparency />} />
        <Route path="/collaborators" element={<Collaborators />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/results" element={<Results />} />
        <Route path="/assistant" element={<Assistant />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/diary" element={<Diary />} />
        <Route path="/archive" element={<Archive />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </PageLayout>
  );
}

function App() {
  return (
    <FontSizeProvider>
      <ThemeProvider>
        <I18nProvider>
          <BrowserRouter>
            <AuthProvider>
              <AppRoutes />
              <Toaster position="top-center" richColors closeButton />
            </AuthProvider>
          </BrowserRouter>
        </I18nProvider>
      </ThemeProvider>
    </FontSizeProvider>
  );
}

export default App;
